import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import Stats from "three/examples/jsm/libs/stats.module";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import {
  CSS2DRenderer,
  CSS2DObject,
} from "three/examples/jsm/renderers/CSS2DRenderer";

if (typeof window !== "undefined") {
  window.THREE = THREE;
}
const THREEJS = {
  ...THREE,
  GLTFLoader,
  OBJLoader,
  FBXLoader,
  OrbitControls,
  CSS2DRenderer,
  CSS2DObject,
  Stats,
};

export default THREEJS;
